import { mapGetters } from "vuex";
import store from "@/store";

export default {
    name: "Header",
    
    data() {
        return {
            isOpen: false
        };
    },

    computed: {
        ...mapGetters({ isCompanyLoggedIn: "isCompanyLoggedIn", companyId: "companyId", companyToken: "companyToken", companyName: "companyName" })
    },

    watch: {
        $route() {
            this.isOpen = false;
        }
    },

    methods: {
        logoutCompany() {
            store.dispatch("companyLogout")
            .then(() => {
                this.$router.push({ name: "companyLogin" });
            })
            .catch((error) => {
                console.log(error);
                this.$router.push({ name: "companyLogin" });
            });
        },
    
        toggle: function(){
            this.isOpen = !this.isOpen
        },

        handleResize() {
            if (window.innerWidth > 1040) {
                this.isOpen = false;
            }
        }
    },

    mounted() {
        window.addEventListener("resize", this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    }
};